
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ChZM", function(module, exports) {

$parcel$export(module.exports, "ImageWrapper", () => $250035b51418e050$export$75f07c36086c2c81);
$parcel$export(module.exports, "LoadingDiv", () => $250035b51418e050$export$caf7b844f87776ef);
$parcel$export(module.exports, "UnsplashLoadingDiv", () => $250035b51418e050$export$e0f0a550d389890d);
$parcel$export(module.exports, "RendererPageCoverPictureComponent", () => $250035b51418e050$export$d8da1ed12fdbdfd1);
$parcel$export(module.exports, "RendererPageCoverPicture", () => $250035b51418e050$export$60620c3d63f5f30);
/* RendererPageCoverPicture.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $btHGY = parcelRequire("btHGY");

var $inPa6 = parcelRequire("inPa6");

var $1iSzD = parcelRequire("1iSzD");

var $e4o8D = parcelRequire("e4o8D");

var $4IoVL = parcelRequire("4IoVL");
var $iP9x4 = parcelRequire("iP9x4");

var $gXrHX = parcelRequire("gXrHX");

var $jVylI = parcelRequire("jVylI");
var $zalpJ = parcelRequire("zalpJ");

var $dIouf = parcelRequire("dIouf");

var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $75Ax4 = parcelRequire("75Ax4");

var $2XV0z = parcelRequire("2XV0z");
const $250035b51418e050$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPresenterMode: isPresenterMode, dynamicCoverImageHeight: dynamicCoverImageHeight, isFullWidthImageOption: isFullWidthImageOption, isFixedWidthImageOption: isFixedWidthImageOption, isPagePreview: isPagePreview, isObjectHeaderEnabled: isObjectHeaderEnabled, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, objectPosition: objectPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pjvxvw": (0, $iAWao.default)(__cmplp.dynamicCoverImageHeight, "px"),
            "--_z440ka": (0, $iAWao.default)(__cmplp.objectPosition)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_5ral1dfr _1bsb1osq _1e0c1txw _rsuf3crg",
            __cmplp.isPresenterMode ? "_4t3i1og9" : __cmplp.isFullWidthImageOption && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr') ? "_4t3i1a28" : __cmplp.isFixedWidthImageOption && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr') ? "_4t3i2pqz" : "_4t3ifmv9",
            __cmplp.isFixedWidthImageOption && "_1bsb1c3h",
            !__cmplp.isPagePreview && "_19pkpxbi",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : __cmplp.isPagePreview ? "_otyrze3t" : "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$export$caf7b844f87776ef = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7n82g _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_18u09b24 _p12f1c3h" : "_18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$export$e0f0a550d389890d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isSpaceOverview: isSpaceOverview, isEmbeddedConfluence: isEmbeddedConfluence, hasUnsplashImageLoaded: hasUnsplashImageLoaded, isObjectHeaderEnabled: isObjectHeaderEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7n82g _1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : __cmplp.isSpaceOverview || __cmplp.isEmbeddedConfluence ? "_1bsb1osq" : "_1bsb14oa",
            __cmplp.hasUnsplashImageLoaded ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$var$UnsplashWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rkon7od _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$var$IdentifierWrapper = ({ children: children, isPagePreview: isPagePreview, isEmbeddedConfluence: isEmbeddedConfluence = false, isFixedWidthImageOption: isFixedWidthImageOption = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ...(0, $luv00.useSSRPlaceholderReplaceIdProp)(),
        className: "renderer-page-cover-picture",
        style: isPagePreview && isFixedWidthImageOption ? {
            display: 'flex',
            justifyContent: 'center'
        } : !isPagePreview ? isFixedWidthImageOption ? {
            marginLeft: 'var(--full-cover-image-margin, 0px)',
            width: isEmbeddedConfluence ? 'unset' : 'var(--full-cover-image-width, 100%)',
            // need to use non-tokenizable value for marginTop since space.negative.300 (-24px)
            // leaves a small gap between the nav bar and content topper
            marginTop: '-26px',
            display: isFixedWidthImageOption ? 'flex' : 'unset',
            justifyContent: isFixedWidthImageOption ? 'center' : 'unset'
        } : {
            marginLeft: 'var(--full-cover-image-margin, 0px)',
            width: isEmbeddedConfluence ? 'unset' : 'var(--full-cover-image-width, 100%)',
            // need to use non-tokenizable value for marginTop since space.negative.300 (-24px)
            // leaves a small gap between the nav bar and content topper
            marginTop: '-26px'
        } : {}
    }, children);
const $250035b51418e050$var$getPageMode = (isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence)=>{
    if (isPagePreview) return 'preview';
    else if (isSpaceOverview) return 'space-overview';
    else if (isPresenterMode) return 'presenter';
    else if (isEmbeddedConfluence) return 'embed';
    else return 'view';
};
const $250035b51418e050$export$d8da1ed12fdbdfd1 = ({ contentId: contentId, isPagePreview: isPagePreview, coverPicture: coverPicture, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, leftRightPaddingValue: leftRightPaddingValue, isPresenterMode: isPresenterMode, coverPictureWidthOverride: coverPictureWidthOverride })=>{
    const { isExternalShareRequest: isExternalShare } = (0, $gwFzn.useContext)((0, $gXrHX.ExternalShareContext));
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const [mediaConfig, setMediaConfig] = (0, $gwFzn.useState)(null);
    const [hasUnsplashImageLoaded, setHasUnsplashImageLoaded] = (0, $gwFzn.useState)(false);
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        isExternalShare: isExternalShare
    });
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isPageSSRed = (isServerPlaceholder || window.__SSR_RENDERED__) && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr');
    const isMediaConfigGateReady = isPageSSRed ? !!ssrConfig : !!mediaConfig;
    const mediaConfigGated = isPageSSRed ? ssrConfig && ssrConfig.config : mediaConfig && {
        authProvider: mediaConfig.authProvider
    };
    const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isFixedWidthImageOption = !isPresenterMode && isFixedWidth;
    const isFullWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const isFullWidthImageOption = !isPresenterMode && isFullWidth;
    const isValidCustomSitesTitleAlignment = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER || titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).LEFT;
    const titleAlignment = isValidCustomSitesTitleAlignment && titleContentProperties && titleContentProperties.titleLayoutAlignment ? titleContentProperties.titleLayoutAlignment : '';
    const leftRightPaddingValueOffset = isPagePreview && leftRightPaddingValue ? leftRightPaddingValue : 0;
    const { height: height } = (0, $2XV0z.usePageHeightWidthObserver)(isPagePreview, leftRightPaddingValueOffset, isPresenterMode);
    const dynamicHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : height; // if we are in page preview, we need to show the draft image/position/appearance since we are in edit mode
    const imageId = (isPagePreview ? coverPicture.draft?.value.id : coverPicture.published?.value.id) || '';
    const position = (isPagePreview ? coverPicture.draft?.value.position : coverPicture.published?.value.position) || '';
    const objectPosition = `center ${position}%`;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)(); // using imageId as key since the query gets outdated information and we need to force a re-render after it gets the
    // correct info
    const isUnsplashCoverImage = !!imageId && imageId.includes('images.unsplash.com');
    const currentPageMode = $250035b51418e050$var$getPageMode(isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence);
    const createViewHeaderImageAnalyticsEvent = (0, $gwFzn.useCallback)((isUnsplash, appearance, pageMode, pageTitleAlignment, isFixedWidthCoverImage)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'HeaderImage',
                actionSubjectId: 'viewPageHeaderImage',
                source: 'viewPageHeaderImage',
                attributes: {
                    headerImageType: isUnsplash ? 'unsplash' : 'user-uploaded',
                    contentAppearance: appearance,
                    pageMode: pageMode,
                    pageTitleAlignment: pageTitleAlignment,
                    coverImageWidth: isFixedWidthCoverImage ? 'fixed-width' : 'full-width'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        createViewHeaderImageAnalyticsEvent(isUnsplashCoverImage, appearance, currentPageMode, titleAlignment, isFixedWidthImageOption);
    }, [
        isUnsplashCoverImage,
        appearance,
        currentPageMode,
        titleAlignment,
        isFixedWidthImageOption,
        createViewHeaderImageAnalyticsEvent
    ]); // Setup media config
    (0, $gwFzn.useEffect)(()=>{
        (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            isExternalShare: isExternalShare
        }).then(({ viewMediaClientConfig: viewMediaClientConfig })=>{
            setMediaConfig({
                collection: `contentId-${contentId}`,
                authProvider: viewMediaClientConfig.authProvider
            });
        });
    }, [
        contentId,
        isExternalShare
    ]); // when confluence_frontend_cover_image_ssr FG is OFF, return placeholder if we somehow don't have mediaConfig or imageId
    // when confluence_frontend_cover_image_ssr FG is ON, return placeholder if there is a custom upload
    if ((!isMediaConfigGateReady || !imageId) && !(isUnsplashCoverImage && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$var$IdentifierWrapper, {
        isPagePreview: isPagePreview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$export$caf7b844f87776ef, {
        isPagePreview: isPagePreview,
        isSpaceOverview: isSpaceOverview,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header')
    }));
    if (isUnsplashCoverImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$var$IdentifierWrapper, {
        isPagePreview: isPagePreview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$var$UnsplashWrapper, {
        key: imageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$export$e0f0a550d389890d, {
        isPagePreview: isPagePreview,
        hasUnsplashImageLoaded: hasUnsplashImageLoaded,
        isSpaceOverview: isSpaceOverview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$export$75f07c36086c2c81, {
        "data-testid": "unsplash-cover-picture",
        "data-vc": "unsplash-cover-picture-renderer" // need this empty alt tag for decorative images
        ,
        alt: "",
        isPagePreview: isPagePreview,
        src: imageId,
        objectPosition: objectPosition,
        onLoad: ()=>{
            setHasUnsplashImageLoaded(true);
        },
        isSpaceOverview: isSpaceOverview,
        hasEmoji: hasEmoji,
        dynamicCoverImageHeight: (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr') ? undefined : dynamicHeight,
        isPresenterMode: isPresenterMode,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isFullWidthImageOption: isFullWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header')
    })));
    else if (isMediaConfigGateReady && mediaConfigGated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        key: imageId,
        identifier: {
            mediaItemType: 'file',
            id: imageId,
            collectionName: isPageSSRed ? `contentId-${contentId}` : mediaConfig?.collection
        },
        mediaClientConfig: mediaConfigGated,
        apiConfig: {
            allowAnimated: true,
            mode: 'full-fit',
            upscale: false
        },
        ssr: isPageSSRed ? ssrConfig?.mode : undefined
    }, ({ data: data, loading: loading })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$var$IdentifierWrapper, {
            isPagePreview: isPagePreview,
            isEmbeddedConfluence: isEmbeddedConfluence,
            isFixedWidthImageOption: isFixedWidthImageOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$export$caf7b844f87776ef, {
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header')
        }));
        if (!data) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$var$IdentifierWrapper, {
            isPagePreview: isPagePreview,
            isEmbeddedConfluence: isEmbeddedConfluence,
            isFixedWidthImageOption: isFixedWidthImageOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($250035b51418e050$export$75f07c36086c2c81, {
            isPagePreview: isPagePreview,
            src: data.src,
            objectPosition: objectPosition,
            isSpaceOverview: isSpaceOverview,
            hasEmoji: hasEmoji,
            dynamicCoverImageHeight: (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr') ? undefined : dynamicHeight,
            isPresenterMode: isPresenterMode,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isFullWidthImageOption: isFullWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header')
        }));
    });
};
const $250035b51418e050$export$60620c3d63f5f30 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PAGE_EXTENSIONS
})($250035b51418e050$export$d8da1ed12fdbdfd1);

});


//# sourceMappingURL=RendererPageCoverPicture.c92a7485.js.map
